
import Radar2 from "../../../assets/duotone/Radar2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Radar2Icon({ className, dataTestid = "Radar2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Radar2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
